export default {"src":"/_next/static/media/bb_logo.d23eff64.svg","height":52,"width":102,"blurWidth":0,"blurHeight":0};